module.exports = __webpack_public_path__ + "static/media/q_nav_7_not_selected.3fe5f824.svg";